import axios from "axios";

export const getPurchaseOrders = async ({ query = {}, controller = null, excludeInterceptor = false }: any) => {	
	const params: any = {params : query, excludeInterceptor}
	if(controller?.signal){
		params.signal = controller.signal
	}

	try {
		const res: any = await axios.get("/purchase-orders", params);
		return res?.data ? res.data : [];
	} catch (e: any) {
		return [];
	}
};

export const getPurchaseOrder = async ({ data, controller = null}: any) => {	
	try {
		const res: any = await axios.get(`/purchase-orders/${data?.id}`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const getPurchaseOrderPayments = async ({ data }: any) => {
	try {
		const res: any = await axios.get(`/purchase-orders/${data?.id}/payments`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const createPurchaseOrderPayment = async ({ id, data }: any) => {
	try {
		const res: any = await axios.post(`/purchase-orders/${id}/payments`, data);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const updatePurchaseOrderPayment = async ({ id, paymentId, data }: any) => {
	try {
		const res: any = await axios.put(`/purchase-orders/${id}/payments/${paymentId}`, data);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const deletePurchaseOrderPayment = async ({ id, paymentId }: any) => {
	try {
		const res: any = await axios.delete(`/purchase-orders/${id}/payments/${paymentId}`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const updatePurchaseOrder = async ({ data, update }: any) => {
	try {
		const res: any = await axios.put(`/purchase-orders/${data?.id}`, update);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const getPoPDF = async ({ data }: any) => {	
	try {
		// Session 28 hotfix 6 (Phase 3): backend reads
		// purchase_order.mulchMapSnapshotIds directly.
		const res: any = await axios.get(`/purchase-orders/${data?.id}/pdf`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const emailPo = async ({ data }: any) => {
	try {
		// Session 28 hotfix 6 (Phase 3): backend reads
		// purchase_order.mulchMapSnapshotIds directly.
		const res: any = await axios.post(`/purchase-orders/${data.id}/send-by-email`, {});
		// Session 65 item 6b: a successful send-by-email response carries a
		// `message` ("email sent"), so callers that inferred failure from the
		// mere presence of `message` showed a RED danger toast on success.
		// Return an explicit success flag: true when the request resolved,
		// false (preserving the server message) when it threw. Mirrors the
		// `res.success` convention emailQuote / acceptOnBehalf already use.
		return { success: true, ...(res?.data ?? {}) };
	} catch (e: any) {
		const body = e?.response?.data ?? {};
		return { success: false, ...(typeof body === "object" ? body : { message: String(body) }) };
	}
};

export const createPONote = async ({ id, content }: any) => {
	try {
		const res: any = await axios.post(`/purchase-orders/${id}/notes`, { content });
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const acceptOrDeny = async ({ data, update }: any) => {
	try {
		const res: any = await axios.post(`/purchase-orders/${data.id}/accept-or-deny`, update);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

// MASTER_PLAN.md §3.9 #11 — PO acknowledgment gate + composable
// disclosure blocks. Called on every first-view Sent-status render
// (modal) and to render subsequent-view banners. See design doc
// docs/maintenance-module/design/PO_VIEW_REFRESH.md.

export const getPoDisclosures = async ({ data }: any) => {
	try {
		const res: any = await axios.get(`/purchase-orders/${data?.id}/disclosures`);
		return res?.data
			? res.data
			: { disclosures: [], termsAcknowledgedAt: null, termsAcknowledgedBy: null };
	} catch (e: any) {
		return { disclosures: [], termsAcknowledgedAt: null, termsAcknowledgedBy: null };
	}
};

export const acknowledgePo = async ({ data }: any) => {
	try {
		const res: any = await axios.post(`/purchase-orders/${data?.id}/acknowledge`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const resetPoAcknowledge = async ({ data }: any) => {
	try {
		const res: any = await axios.post(`/purchase-orders/${data?.id}/acknowledge/reset`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const addPOFile = async ({ id, data }: any) => {
	try {
		const res: any = await axios.post(`/purchase-orders/${id}/files`, data);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const getPOFiles = async ({ data, controller = null}: any) => {	
	try {
		const res: any = await axios.get(`/purchase-orders/${data?.id}/files`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const deletePOFile = async ({ data, controller = null}: any) => {	
	try {
		const res: any = await axios.delete(`/purchase-orders/${data?.id}/files/${data?.fileId}`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const getProjectPurchaseOrders = async ({ data }: any) => {
	try {
		const res: any = await axios.post(`/purchase-orders/project-purchase-orders`, { id: data?.id });
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const resyncPO = async ({ data }: any) => {
	try {
		const res: any = await axios.post(`/purchase-orders/${data?.id}/resync`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const createPO = async ({ data }: any) => {
	try {
		const res: any = await axios.post(`/purchase-orders`, data);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};
